module.exports = __webpack_public_path__ + "static/img/frame 6.2dc9d651.png";